export const ClaimStructureAllotmentJson = {
  screenTitle: "Claim Structure Assignation",

  fieldMetaForArea: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
        {
          label: "Type Wise",
          value: "3",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Claim Structure",
      controlType: "autocomplete",
      placeHolder: "Select Claim Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "claimStructureDetail",
      dataKey: "claimStructure",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Region",
      controlType: "autocomplete",
      placeHolder: "Select Region",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "regionDetail",
      dataKey: "region",
      getListId: "region",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "State",
      controlType: "autocomplete",
      placeHolder: "Select State",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stateDetail",
      dataKey: "state",
      getListFrom: "region",
      getListId: "state",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Zone",
      controlType: "multiSelect",
      placeHolder: "Select Zone",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "zoneDetail",
      dataKey: "zone",
      getListFrom: "state",
      getListId: "zone",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "District",
      controlType: "multiSelect",
      placeHolder: "Select District",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "districtDetail",
      dataKey: "district",
      getListFrom: "zone",
      getListId: "district",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Taluka",
      controlType: "multiSelect",
      placeHolder: "Select Taluka",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "talukaDetail",
      dataKey: "taluka",
      getListFrom: "district",
      getListId: "taluka",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "taluka",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForAreaGetById: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
        {
          label: "Type Wise",
          value: "3",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Region",
      controlType: "autocomplete",
      placeHolder: "Select Region",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "regionDetail",
      dataKey: "region",
      getListId: "region",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "State",
      controlType: "autocomplete",
      placeHolder: "Select State",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stateDetail",
      dataKey: "state",
      getListFrom: "region",
      getListId: "state",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Zone",
      controlType: "multiSelect",
      placeHolder: "Select Zone",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "zoneDetail",
      dataKey: "zone",
      getListFrom: "state",
      getListId: "zone",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "District",
      controlType: "multiSelect",
      placeHolder: "Select District",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "districtDetail",
      dataKey: "district",
      getListFrom: "zone",
      getListId: "district",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Taluka",
      controlType: "multiSelect",
      placeHolder: "Select Taluka",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "talukaDetail",
      dataKey: "taluka",
      getListFrom: "district",
      getListId: "taluka",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "taluka",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForSalesTeam: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
        {
          label: "Type Wise",
          value: "3",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Claim Structure",
      controlType: "autocomplete",
      placeHolder: "Select Claim Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "claimStructureDetail",
      dataKey: "claimStructure",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesPersonDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForSalesTeamGetById: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
        {
          label: "Type Wise",
          value: "3",
        },
      ],
      isMandatory: true,
    },

    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesPersonDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForUnderSalesTeam: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
        {
          label: "Type Wise",
          value: "3",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Claim Structure",
      controlType: "autocomplete",
      placeHolder: "Select Claim Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "claimStructureDetail",
      dataKey: "claimStructure",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesPersonDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Type",
      controlType: "multiSelect",
      placeHolder: "Select Stake Holder Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "typeDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamTypeId",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForUnderSalesTeamGetById: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
        {
          label: "Type Wise",
          value: "3",
        },
      ],
      isMandatory: true,
    },

    {
      label: "Sales Team Type",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesPersonDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Type",
      controlType: "multiSelect",
      placeHolder: "Select Stake Holder Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "typeDetail",
      getListFrom: "stockHolderType",
      dataKey: "salesTeamTypeId",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForTypeWise: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
        {
          label: "Type Wise",
          value: "3",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Claim Structure",
      controlType: "autocomplete",
      placeHolder: "Select Claim Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "claimStructureDetail",
      dataKey: "claimStructure",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Sales Team Type",
      controlType: "multiSelect",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForTypeWiseGetById: [
    {
      label: "Type",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Area Wise",
          value: "0",
        },
        {
          label: "Sales Team Wise",
          value: "1",
        },
        {
          label: "Sales Team By Type Wise",
          value: "2",
        },
        {
          label: "Type Wise",
          value: "3",
        },
      ],
      isMandatory: true,
    },

    {
      label: "Sales Team Type",
      controlType: "multiSelect",
      placeHolder: "Select Sales Team Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
};
